/**
 * Error that is thrown when a file type is not supported
 */
export class MaxFileSizeExceededError extends Error {
    constructor(message, file) {
        super(message);
        Object.defineProperty(this, "file", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'MaxFileSizeExceededError';
        this.file = file;
    }
}
//# sourceMappingURL=MaxFileSizeExceededError.js.map